import styled from 'styled-components'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.small ? '100%' : 'fit-content')};
  align-items: ${props => (props.leftAlign ? 'flex-start' : 'center')};

  & h2 {
    padding-bottom: 66px;
  }

  & h3 {
    padding-bottom: 46px;
    color: var(--forest);
  }

  @media (max-width: ${sizeMobile}) {
    width: 100%;
    align-items: flex-start;

    & h2,
    & h3 {
      text-align: center;
    }
  }
`

export const MainList = styled.ol`
  width: ${props => (props.small ? 'calc(100% - 32px)' : `${props.width}px`)};
  counter-reset: number;

  & li {
    list-style-type: none;
    padding-bottom: 32px;
    display: flex;
    position: relative;

    &::before {
      counter-increment: number;
      content: '0'counter(number);
      font-weight: 600;
      font-size: 2rem;
      font-variant-numeric: tabular-nums;
      padding-right: 16px;
    }

    & details {
      display: inline;

      &[open] summary::after {
        transform: rotate(180deg);
      }

      & summary {
        list-style: none;
        cursor: pointer;

        &::-webkit-details-marker {
          display: none;
        }

        &::after {
          content: '▾';
          font-size: 2.4rem;
          position: absolute;
          top: 0;
          right: ${props => (props.small ? '-32px' : 0)};

          @media (max-width: ${sizeMobile}) {
            right: -32px;
          }
        }
      }
    }
  }

  @media (max-width: ${sizeMobile}) {
    width: calc(100% - 32px);
  }
`
